export const mailPassForm = [
        {
            cols: [
                {
                    formGroup: 'mailPassForm',
                    class: 'col-lg-8 col-10',
                    title: 'Alta en el área de clientes',
                    titleClass: 'form-title text-center'
                },
                {
                    class: 'col-10',
                    subtitle: 'Introduce los datos que desearás utilizar en el área de clientes.',
                    subtitleClass: 'form-subtitle text-center'

                },
                {
                    class: 'col-10',
                    subtitle: 'Recuerda que la contraseña debe tener 8 caracteres y, al menos, una mayúscula',
                    subtitleClass: 'form-subtitle text-center font-weight-bold'
                }
            ]
        },
        {
            cols: [
                {
                    class: 'col-lg-6 col-10',
                    item: 'input',
                    type: 'email',
                    required: true,
                    placeholder: 'Email',
                    inputClass: 'text-input',
                    formControlName: 'email'
                }
            ]
        },
        {
            cols: [
                {
                    class: 'col-lg-6 col-10',
                    item: 'input',
                    type: 'password',
                    required: true,
                    placeholder: 'Contraseña',
                    inputClass: 'text-input',
                    formControlName: 'password'
                }
            ]
        },
        {
            cols: [
                {
                    class: 'col-lg-6 col-10',
                    item: 'input',
                    type: 'password',
                    required: true,
                    placeholder: 'Repite la contraseña',
                    inputClass: 'text-input',
                    formControlName: 'confirmPassword'
                }
            ]
        },
        {
            cols: [
                {
                    class: 'col-lg-6 col-10',
                    item: 'button',
                    type: 'regular',
                    submit: 'true',
                    placeholder: 'Guardar',
                    inputClass: 'form-button btn btn-primary',
                    buttonAction: 'onSubmit'
                }
            ]
        }
    ]
;

